import { render, staticRenderFns } from "./SignerCard.vue?vue&type=template&id=38b5bc98&scoped=true"
import script from "./SignerCard.vue?vue&type=script&lang=js"
export * from "./SignerCard.vue?vue&type=script&lang=js"
import style0 from "./SignerCard.vue?vue&type=style&index=0&id=38b5bc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5bc98",
  null
  
)

export default component.exports